"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCertificationBadRequestResponseDto = instanceOfCertificationBadRequestResponseDto;
exports.CertificationBadRequestResponseDtoFromJSON = CertificationBadRequestResponseDtoFromJSON;
exports.CertificationBadRequestResponseDtoFromJSONTyped = CertificationBadRequestResponseDtoFromJSONTyped;
exports.CertificationBadRequestResponseDtoToJSON = CertificationBadRequestResponseDtoToJSON;
exports.CertificationBadRequestResponseDtoToJSONTyped = CertificationBadRequestResponseDtoToJSONTyped;
const RqiDataDto_1 = require("./RqiDataDto");
/**
 * Check if a given object implements the CertificationBadRequestResponseDto interface.
 */
function instanceOfCertificationBadRequestResponseDto(value) {
    if (!('error' in value) || value['error'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined)
        return false;
    if (!('reasons' in value) || value['reasons'] === undefined)
        return false;
    if (!('pdfLink' in value) || value['pdfLink'] === undefined)
        return false;
    if (!('rqiData' in value) || value['rqiData'] === undefined)
        return false;
    return true;
}
function CertificationBadRequestResponseDtoFromJSON(json) {
    return CertificationBadRequestResponseDtoFromJSONTyped(json, false);
}
function CertificationBadRequestResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'error': json['error'],
        'message': json['message'],
        'statusCode': json['statusCode'],
        'reasons': json['reasons'],
        'pdfLink': json['pdfLink'],
        'rqiData': (0, RqiDataDto_1.RqiDataDtoFromJSON)(json['rqiData']),
    };
}
function CertificationBadRequestResponseDtoToJSON(json) {
    return CertificationBadRequestResponseDtoToJSONTyped(json, false);
}
function CertificationBadRequestResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'error': value['error'],
        'message': value['message'],
        'statusCode': value['statusCode'],
        'reasons': value['reasons'],
        'pdfLink': value['pdfLink'],
        'rqiData': (0, RqiDataDto_1.RqiDataDtoToJSON)(value['rqiData']),
    };
}
//# sourceMappingURL=CertificationBadRequestResponseDto.js.map